



import {allNumeric } from './dateConverter';

 
 export const API_URL =  import.meta.env.VITE_API_URL;



export async function fetchAndRenderData(tripId) {


    try {
        // Fetch budget

        const response = await fetch(`${API_URL}/tripTotalInfo/${tripId}`,
            {
                method: 'GET', // Use 'POST' for login
                credentials: 'include', // ✅ Required for cookies

            }
        );

        if (!response.ok) {
          
            return null;


        }

        const data = await response.json();
      


        return data;



    } catch (error) {
        console.error("Error fetching data:", error);
        return null;

    }
}


export async function setCurrentTrip(trip) {

    try {
     

        const responce = await fetch(`${API_URL}/setCurrentTrip?currentTripId=${encodeURIComponent(trip)}`, {


            method: 'PUT',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' }
        });

        if (!responce.ok) {
            console.error('Network response was not ok');
            const data = await responce.json();
            console.log(data);
            return NaN
        }

        const data = await responce.json();
      
        return (data.message.current_trip_id);

    } catch (error) {
        console.error(error);
        return NaN
    }



}






//need to make sure i pass navigate as a parameter always when i call this function

/* this function returns  
    currentTripInfo
    total - total Trips
    totalExpenses - based on currant trip
    trips - all trips info
*/




export async function fetchAndRenderAllData() {


    try {
        // Fetch budget

        const response = await fetch(`${API_URL}/totalTrips`,
            {
                method: 'GET', // Use 'POST' for login
                credentials: 'include', // ✅ Required for cookies

            }
        );
       
        if (!response.ok) {
           
         
            return { data: '', status: response.status };
           
        }
        const data = await response.json();
     

        return { data, status: response.status };


    } catch (error) {
        console.error("Error fetching data:", error);
        return { data: '', status: error };

    }
}


/* 
this function returns 
  users current trip id
  current trip_name
  users first Name

*/

export const getUserInfo = async () => {
    try {
        const response = await fetch(`${API_URL}/userInfo`, {
            method: 'GET',
            credentials: 'include',
        });

        if (!response.ok) {
            if (response.status === 401) {
                console.warn('User not logged in');
                return { loggedIn: false, data: '', trips: false }; // Exit early, don't set state
            }

            throw new Error('Network response was not ok');
        }
       

        const data = await response.json();
        

         if (response.status === 202) {
            return { loggedIn: true, data: data, trips: false };


        }



        return { loggedIn: true, data: data, trips: true };
    } catch (error) {
        console.error('Error fetching user info:', error);
        return { loggedIn: false, data: '', trips: false };
    }
};


             

export async function fetchAndRenderExpenses(navigate, currentTripId) {
   
    if (!currentTripId) return
    try {

        // Fetch budget
        const expensesResponse = await fetch(`${API_URL}/expenses?tripId=${currentTripId}`, {
            method: 'GET', // Use 'POST' for login
            credentials: 'include', // ✅ Required for cookies

        });
       
        if (!expensesResponse.ok) {
           
            if (expensesResponse.status === 401) {
                navigate;
            }
            
            return {status: false, data: ''}
        }
        if (expensesResponse.status === 204) {
          
            return {status: false, data: ''}
        }

        const expensesData = await expensesResponse.json();

        return {status: true, data: expensesData};






    } catch (error) {
        console.error("Error fetching data:", error);
        
            return {status: false, data: ''}

    }
}


export async function sendMessage(name, email, userMessage) {

    

    try {

        // Fetch budget
        const response = await fetch(`${API_URL}/messages`, {
            method: 'POST', // Use 'POST' for login
            credentials: 'include', // ✅ Required for cookies
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ name, email, userMessage })


        });

        if (!response.ok) {
           
            const data = await response.json();
            const error = data.message;
            return { error, success: false };
        }


        const data = await response.json();
        console.log(data);


        return { error: '', success: true }





    } catch (error) {
        console.error("Error fetching data:", error.message);
        return error.message;

    }

}





 const getWeatherData = async (id) => {
    
      
        try {
             const response = await fetch(`${API_URL}/weather`,
                   {
                       method: 'GET', // Use 'POST' for login
                       credentials: 'include', // ✅ Required for cookies
   
                   }
               );
          
             
               if(response.ok){
                      
                const data = await response.json();
               
               localStorage.setItem(`weatherForTrip${id}`, JSON.stringify(data));
               
              return {data: data.data};

               }
             
                  return null;

                 
              
                
            
        } catch (error) {
            console.error(error);
            return null;
            
        }
              
   
           }



export async function weatherPageInfo() {
    try {
        const response = await fetch(`${API_URL}/weather/pageInfo`, {
            method: 'GET',
            credentials: 'include',
        });

      
        if (!response.ok){



            if (response.status === 400){
            return {status: response.status}
            }
               const data = await response.json();
               console.error(data);
               return {status: response.status}

        }
        const data = await response.json();
       
        
        const {location, currentWeatherData} = data;

         
                let img = null, state = null, country= null, city= null;
              
                
                if(location.img){
                  img = location.img;
                }
                if(location.city){
                  city = location.city;
                }
                if(location.state){
                  state = location.state;
                }
                if(location.country){
                  country = location.country;
                  console.log(country);
                }
















              
               const lsWeather = localStorage.getItem(`weatherForTrip${location.id}`)
               
               if (!lsWeather){
                console.log('local storage is empty');
                    const newData = await getWeatherData(location.id);
                
                    if(newData){
                         
                        return {data: newData.data, img, state, city, currentWeatherData, status: response.status};
                    } 
                  
                   return {status: response.status}
   
               } else{
                
               const parsedWeather = JSON.parse(lsWeather);
                console.log('got it from local storage');
                
                const dateFromLs = new Date(parsedWeather.data[0].interval.startTime).toLocaleDateString("en-US", allNumeric);
                const today = new Date().toLocaleDateString("en-US", allNumeric);
                
                if(dateFromLs === today){
               
                 
                    return {data: parsedWeather.data, img, state, city, currentWeatherData, status: response.status};

                }else if(dateFromLs !== today){
                    localStorage.removeItem(`weatherForTrip${data.id}`)
                 
                     const newData = await getWeatherData(location.id);
                     if(newData){
                     
                        return {data: newData.data, img, state, city, currentWeatherData, status: response.status};
                       
                    } 
                   
                   return {status: response.status}
                } 

               }
          




        

    } catch (error) {
        console.error('error:', error);
           return {status: '500'}
    }
}





 

    
